/**
 * カスタム設定ボタン（オーバーレイ開閉）
 */
export const CUSTOM_BUTTON = {
  selectors: {
    root: '.js-custom-button',
    trigger: '.c-button--custom',
    overlay: '.c-button__overlay',
  },

  classNames: {
    open: 'is-open',
  },

  init() {
    const roots = document.querySelectorAll(this.selectors.root)

    if (!roots.length) {
      return
    }

    roots.forEach(root => {
      const trigger = root.querySelector(this.selectors.trigger)
      const overlay = root.querySelector(this.selectors.overlay)

      if (!trigger || !overlay) {
        return
      }

      trigger.setAttribute('aria-expanded', 'false')
      trigger.setAttribute('aria-haspopup', 'true')

      trigger.addEventListener('click', event => {
        event.stopPropagation()
        this.toggle(root, trigger)
      })
    })

    document.addEventListener('click', event => {
      roots.forEach(root => {
        if (!root.classList.contains(this.classNames.open)) {
          return
        }

        if (root.contains(event.target)) {
          return
        }

        this.close(root)
      })
    })

    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') {
        return
      }

      this.closeAll()
    })
  },

  toggle(root, trigger) {
    const isOpen = root.classList.contains(this.classNames.open)

    this.closeAll()

    if (!isOpen) {
      this.open(root, trigger)
    }
  },

  open(root, trigger) {
    const button = trigger || root.querySelector(this.selectors.trigger)

    root.classList.add(this.classNames.open)

    if (button) {
      button.setAttribute('aria-expanded', 'true')
    }
  },

  close(root) {
    const trigger = root.querySelector(this.selectors.trigger)

    root.classList.remove(this.classNames.open)

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false')
    }
  },

  closeAll() {
    document.querySelectorAll(this.selectors.root).forEach(root => {
      this.close(root)
    })
  },
}
